var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.state)?_c('div',{staticClass:"loading-overlay w-100 h-100 bg-white d-flex align-items-center justify-content-center"},[_c('img',{staticClass:"loading-overlay__img",attrs:{"src":require('@assets/images/ufo.png'),"alt":"UFO"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }